module.exports = __webpack_public_path__ + "img/50_12.78384dac.png";